class MainSearch extends SearchForm {
  constructor() {
    super();
    this.allSearchInputs = document.querySelectorAll('input[type="search"]');

    this.setupEventListeners();

    if (window.location.pathname.includes('/search')) {
      /**
       * Initial Page Load Search Tracking
       * Publishes the 'searchQuery' event for the Shopify results page.
       */
      const executePublish = () => {
        if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
          const urlParams = new URLSearchParams(window.location.search);
          const q = urlParams.get('q');
          if (q) {
            const products = Array.from(document.querySelectorAll('#product-grid .grid__item'));
            const productsCountElement = document.querySelector('[data-results-count]');
            const productsCount = productsCountElement ? parseInt(productsCountElement.getAttribute('data-results-count'), 10) : products.length;

            const productIds = products
              .map((p) => p.querySelector('[data-product-handle]')?.getAttribute('data-product-handle') || '')
              .filter(Boolean);

            publish(PUB_SUB_EVENTS.searchQuery, {
              query: q,
              search_context: 'results_page',
              engine: 'shopify',
              products_count: productsCount,
              collections_count: 0,
              result_product_ids: productIds,
            });
          }
        }
      };

      /**
       * Polls the DOM for product grid items to ensure accurate counts on dynamic loads.
       * Safety timeout at 2 seconds for true "no results" cases.
       */
      const waitForResults = () => {
        let attempts = 0;
        const poll = () => {
          const hasProducts = document.querySelectorAll('#product-grid .grid__item').length > 0;
          const isTimeout = attempts >= 10; // Max 2 seconds (200ms * 10)

          if (hasProducts || isTimeout) {
            // Small delay to ensure any sync subscribers in the same task are registered
            setTimeout(executePublish, 0);
          } else {
            attempts++;
            setTimeout(poll, 200);
          }
        };
        poll();
      };

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', waitForResults);
      } else {
        waitForResults();
      }
    }
  }

  setupEventListeners() {
    let allSearchForms = [];
    this.allSearchInputs.forEach((input) => allSearchForms.push(input.form));
    this.input.addEventListener('focus', this.onInputFocus.bind(this));
    if (allSearchForms.length < 2) return;
    allSearchForms.forEach((form) => form.addEventListener('reset', this.onFormReset.bind(this)));
    this.allSearchInputs.forEach((input) => input.addEventListener('input', this.onInput.bind(this)));
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.keepInSync('', this.input);
    }
  }

  onInput(event) {
    const target = event.target;
    this.keepInSync(target.value, target);
  }

  onInputFocus() {
    const isSmallScreen = window.innerWidth < 750;
    if (isSmallScreen) {
      this.scrollIntoView({ behavior: 'smooth' });
    }
  }

  keepInSync(value, target) {
    this.allSearchInputs.forEach((input) => {
      if (input !== target) {
        input.value = value;
      }
    });
  }
}

customElements.define('main-search', MainSearch);
